<div [@routerTransition]>
    <div class="kt-subheader kt-grid__item">
        <div class="kt-subheader__main">
            <h3 class="kt-subheader__title">
                <span translation="Axilla.App.Webshop.Configuration" source="Axilla"></span>
            </h3>
        </div>
    </div>
    <div class="kt-content">
        <div class="kt-portlet">
            <div class="kt-portlet__body">
  
                        <div class="row m-form">
                            <div class="col-md-6">
                                <h5>
                                    <span translation="Axilla.App.Webshop.OrderGuides.Banner" source="Axilla"></span>
                                </h5>

                                <ng-container *ngIf="isOGAvailable">
                                    <div class="ui-helper-clearfix">
                                        <div class="p-grid" style="align-items: center;">
                                            <div class="p-col-12 p-md-4" style="min-width: 340px !important">
                                                <p-dropdown [options]="ddOG"
                                                            [style]="{'width':'100%'}"
                                                            [(ngModel)]="selectedOg"
                                                            (onChange)="onSelectOg($event)"></p-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="selectedOg">
                                    <div class="m-2">
                                        <ng-container *ngIf="!isBannerExist">
                                            No Existing Banners
                                        </ng-container>

                                        <ng-container *ngIf="isBannerExist">
                                            <p-dropdown [options]="ddOGBanner"
                                                        [style]="{'width':'100%'}"
                                                        [(ngModel)]="selectedBanner"
                                                        (onChange)="onBannerSelect($event)"></p-dropdown>

                                            <ng-container *ngIf="selectedBanner">
                                                <app-webshop-banner [selected]="selectedOg" [bannerName]="selectedBanner"></app-webshop-banner>
                                            </ng-container>
                                        </ng-container>
                                    </div>


                                    <div class="m-2">
                                        <form #bannerUploadForm>
                                            <div class="form-group">
                                                <input type="file"
                                                       ng2FileSelect
                                                       [uploader]="bannerUploader"
                                                       class="col-lg-12"
                                                       required />

                                                <span class="form-text text-muted col-lg-12">{{"Axilla.App.Webshop.UploadBanner_Info" | localizeAxilla}}</span>
                                            </div>

                                            <button class="btn btn-primary"
                                                    type="button"
                                                    (click)="uploadBanner()">
                                                {{"Upload" | localize}}
                                            </button>

                                            <button class="btn btn-default"
                                                    type="button"
                                                    [disabled]="isDeleteDisabled()"
                                                    (click)="clearBanner()">
                                                {{"Clear" | localize}}
                                            </button>
                                        </form>
                                    </div>
                                </ng-container>
                            </div>
                            
                        </div>
                   
            </div>
        </div>
    </div>
</div>
